import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../hero/Hero";
import MarqueeSection from "./MarqueeSection";
import AboutSection from "./AboutSection";
import ServiceSliderSection from "./ServiceSliderSection";
import Testimonial from "./Testimonial";
import ChooseUsSection from "./ChooseUsSection";
import AboutUsProject from "../aboutUs/AboutUsProject";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when pathname changes
  },);
  return (
    <>
       <Helmet>
  {/* Basic Meta */}
  <meta charSet="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>AppNexts - Your Partner in Development & Digital Solutions</title>
  <meta
    name="description"
    content="AppNexts offers expert App Development, Web Development, UI/UX Design, Digital Marketing, SEO, Graphic Design, Data Analysis, Video Editing, and more. Build your future with us!"
  />
  <meta
    name="keywords"
    content="App Development, Web Development, UI/UX Design, SEO optimization, Digital Marketing, Graphic Design, Data Analysis, SEO services, Web Development Company, Data Structuring, Video Editing Services, Custom IT Solutions"
  />
  <meta name="robots" content="index, follow" />
  <meta httpEquiv="Content-Language" content="en" />
  <meta property="og:locale" content="en_US" />

  {/* Canonical */}
  <link rel="canonical" href="https://www.appnexts.com" />

  {/* Open Graph (Facebook/LinkedIn) */}
  <meta property="og:title" content="AppNexts - Your Partner in Development & Digital Solutions" />
  <meta
    property="og:description"
    content="Explore AppNexts for expert app and web development services, digital marketing, graphic design, data analysis, and more. Your go-to for innovative digital solutions."
  />
  <meta property="og:image" content="https://www.appnexts.com/seo_image/home_seo.png" />
  <meta property="og:url" content="https://www.appnexts.com/" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AppNexts" />

  {/* Twitter Card */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="AppNexts - Your Partner in Development & Digital Solutions" />
  <meta
    name="twitter:description"
    content="AppNexts offers expert app development, web development, SEO, UI/UX design, and digital marketing services. Join us to build your digital future!"
  />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/home_seo.png" />

  {/* Structured Data (JSON-LD) */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "AppNexts",
      "url": "https://www.appnexts.com",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.appnexts.com/seo_image/appnexts.png",
        "width": 512,
        "height": 512
      },
      "sameAs": [
        "https://www.facebook.com/people/Appnexts/61568551576819",
        "https://www.linkedin.com/company/appnexts",
        "https://www.youtube.com/@AppNexts"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+923092018872",
        "email": "contact@appnexts.com",
        "contactType": "Customer Service",
        "areaServed": ["PK", "US", "IN"],
        "availableLanguage": ["English", "Urdu"]
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "M10 Mezzanine Floor, Siddiq Trade Center, Main Boulevard Gulberg Block H, Gulberg 2",
        "addressLocality": "Lahore",
        "addressRegion": "Punjab",
        "postalCode": "54000",
        "addressCountry": "PK"
      }
    })}
  </script>
</Helmet>


      {/* Page Content */}
      <div>
      <HeroSection/>
      <MarqueeSection/>
      <AboutSection/>
      <ServiceSliderSection/> 
      <ChooseUsSection/>
      <AboutUsProject/>
      <Testimonial/>
      </div>
    </>
  );
};

export default Home;
